import moment from "moment"
import { useEffect, useState } from "react"
import { private_server } from "../../../config"
import {  updateAuthorizationHeader } from "../../../shared/utility"

const useProfileView = ({user, history, match, onUpdateUserData}) => {
    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [profile_view, setProfileView] = useState(false)

    const [error, setError] = useState(null)

    const [users, setUsers] = useState([])
    const [total, setTotal] = useState(10)

    const [selected_user, setSelectedUser] = useState(null)

    const [query, setQuery] = useState('')
    const [tableFilter, setTableFilter] = useState({
        limit:10,
        offset:0,
        order:1,
        order_by:'_id',
        user_type_id:1
    })


    const [modals, setModals] = useState({
        add_user:false,
        edit_user:false,
        change_password:false,
        change_avatar:false,
    })

    useEffect(()=>{window.scrollTo(0,0)},[])

    useEffect(() => {
        if(user) actions.onInitModule()
    }, [user])

    const actions = {
        onInitModule: async() => {
            try {
                setLoading(true)
                const _user = await private_server.get(`/user/me`)
                setSelectedUser(_user.data.data.user)
                setLoading(false)
                
            } catch (error) {
                console.log(error)
            }
        },
        onRefreshData: async() => {
            try {
                const _user = await private_server.get(`/user/me`)
                console.log(_user.data.data.user)
                setSelectedUser(_user.data.data.user)
                onUpdateUserData(_user.data.data.user)
            } catch (error) {
                console.log(error)
            }
        },
        onUpdateUsers: async() => {
            try {
                const _user = await private_server.get(`/user/me`)
                console.log(user)
                setSelectedUser(_user.data.data)
                onUpdateUserData(_user.data.data.user)
            } catch (error) {
                
            }
            
        },
        onUpdateQuery:(data) => {
            setQuery(data)
        },
        onSelectedItem: () => {

        },
        onUpdateUser: (data) => {
            setSelectedUser(data)
        },
        onUpdateTableFilter: (data) => {
            setTableFilter(data)
        },
        onUpdateModal: (_key, _value) => {
            let _modals = {...modals, [_key]:_value}
            setModals(_modals)
        }

    }

    const system = {loading, sending, error}
    const view_data = {users, selected_user, query, tableFilter, total, profile_view}

    return {system, modals, view_data, actions}
}

export default useProfileView